import { Component, Inject } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'show-file-dialog',
    templateUrl: 'show-file-dialog.component.html',
    styleUrls: ['show-file-dialog.component.scss']
})
export class ShowFileDialog {
    objectKeys = Object.keys;
    fileurl: string;

    constructor(
        private appService: AppService,
        public dialogRef: MatDialogRef<ShowFileDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if (data instanceof Array) {
            data.forEach(file => {
                if (file.show) {
                    this.appService.downloadDocument(file.url, file.name).subscribe((res)=>{
                        file.url = URL.createObjectURL(res);
                    })
                }
            });
        } else {
            this.appService.downloadDocument(this.data.url, this.data.name).subscribe((res)=>{
                this.fileurl = URL.createObjectURL(res)
            })
        }
    }

    dismissDialog(){
        this.dialogRef.close();
    }
}